import { toast } from "react-toastify";
import {
  PRODUCT_ADD_SUCCESS,
  PRODUCT_ADD_REQUEST,
  PRODUCT_ADD_FAIL,
  //
  PRODUCT_LIST_SUCCESS,
  PRODUCT_LIST_REQUEST,
  PRODUCT_LIST_FAIL,
  //
  PRODUCT_DETAIL_SUCCESS,
  PRODUCT_DETAIL_REQUEST,
  PRODUCT_DETAIL_FAIL,
  //
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_FAIL,
  //
  PRODUCT_UPDATE_SUCCESS,
  PRODUCT_UPDATE_REQUEST,
  PRODUCT_UPDATE_FAIL,
  //
  PRODUCT_EXTRA_LIST_SUCCESS,
  PRODUCT_EXTRA_LIST_REQUEST,
  PRODUCT_EXTRA_LIST_FAIL,
  //
  PRODUCT_EXTRA_DELETE_SUCCESS,
  PRODUCT_EXTRA_DELETE_REQUEST,
  PRODUCT_EXTRA_DELETE_FAIL,
  PRODUCT_EXTRA_DELETE_RESET,
  //
  PRODUCT_EXTRA_ADD_SUCCESS,
  PRODUCT_EXTRA_ADD_REQUEST,
  PRODUCT_EXTRA_ADD_FAIL,
  PRODUCT_EXTRA_ADD_RESET,
  //
  PRODUCT_EXTRA_ADD_ITEM_SUCCESS,
  PRODUCT_EXTRA_ADD_ITEM_REQUEST,
  PRODUCT_EXTRA_ADD_ITEM_FAIL,
  PRODUCT_EXTRA_ADD_ITEM_RESET,
  //
  PRODUCT_EXTRA_DELETE_ITEM_SUCCESS,
  PRODUCT_EXTRA_DELETE_ITEM_REQUEST,
  PRODUCT_EXTRA_DELETE_ITEM_FAIL,
  PRODUCT_EXTRA_DELETE_ITEM_RESET,
  //
} from "../constants/productConstants";

export const createNewExtraItemReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_EXTRA_ADD_ITEM_REQUEST:
      return {
        ...state,
        loadingProductExtraItemAdd: true,
        successProductExtraItemAdd: false
      };
    case PRODUCT_EXTRA_ADD_ITEM_SUCCESS:
      toast.success("This Item has been added successfully");
      return {
        loadingProductExtraItemAdd: false,
        successProductExtraItemAdd: true,
      };
    case PRODUCT_EXTRA_ADD_ITEM_FAIL:
      toast.error(action.payload);
      return {
        loadingProductExtraItemAdd: false,
        successProductExtraItemAdd: false,
        errorProductExtraItemAdd: action.payload,
      };
    // Add a reset action to clear the success state
    case PRODUCT_EXTRA_ADD_ITEM_RESET:
      return {
        ...state,
        successProductExtraItemAdd: false
      };
    default:
      return state;
  }
};

export const createNewExtraReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_EXTRA_ADD_REQUEST:
      return {
        ...state,
        loadingProductExtraAdd: true,
        successProductExtraAdd: false
      };
    case PRODUCT_EXTRA_ADD_SUCCESS:
      toast.success("This Extra has been added successfully");
      return {
        loadingProductExtraAdd: false,
        successProductExtraAdd: true,
      };
    case PRODUCT_EXTRA_ADD_FAIL:
      toast.error(action.payload);
      return {
        loadingProductExtraAdd: false,
        successProductExtraAdd: false,
        errorProductExtraAdd: action.payload,
      };
    // Add a reset action to clear the success state
    case PRODUCT_EXTRA_ADD_RESET:
      return {
        ...state,
        successProductExtraAdd: false
      };
    default:
      return state;
  }
};

export const deleteExtraReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_EXTRA_DELETE_REQUEST:
      return {
        ...state,
        loadingProductExtraDelete: true,
        successProductExtraDelete: false
      };
    case PRODUCT_EXTRA_DELETE_SUCCESS:
      toast.success("This Extra has been successfully deleted.");
      return {
        loadingProductExtraDelete: false,
        successProductExtraDelete: true,
      };
    case PRODUCT_EXTRA_DELETE_FAIL:
      return {
        loadingProductExtraDelete: false,
        errorProductExtraDelete: action.payload,
        successProductExtraDelete: false,
      };
    // Add a reset action to clear the success state
    case PRODUCT_EXTRA_DELETE_RESET:
      return {
        ...state,
        successProductExtraDelete: false
      };
    default:
      return state;
  }
};

export const deleteExtraItemReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_EXTRA_DELETE_ITEM_REQUEST:
      return {
        ...state,
        loadingProductExtraItemDelete: true,
        successProductExtraItemDelete: false
      };
    case PRODUCT_EXTRA_DELETE_ITEM_SUCCESS:
      toast.success("This Extra Item has been successfully deleted.");
      return {
        loadingProductExtraItemDelete: false,
        successProductExtraItemDelete: true,
      };
    case PRODUCT_EXTRA_DELETE_ITEM_FAIL:
      toast.error(action.payload);
      return {
        loadingProductExtraItemDelete: false,
        errorProductExtraItemDelete: action.payload,
        successProductExtraItemDelete: false,
      };
    // Add a reset action to clear the success state
    case PRODUCT_EXTRA_DELETE_ITEM_RESET:
      return {
        ...state,
        successProductExtraItemDelete: false
      };
    default:
      return state;
  }
};

export const listExtraProductReducer = (state = { extras: [] }, action) => {
  switch (action.type) {
    case PRODUCT_EXTRA_LIST_REQUEST:
      return { loadingListExtraProduct: true, extras: [] };
    case PRODUCT_EXTRA_LIST_SUCCESS:
      return {
        loadingListExtraProduct: false,
        extras: action.payload.extras,
        pages: action.payload.pages,
        page: action.payload.page,
      };
    case PRODUCT_EXTRA_LIST_FAIL:
      return {
        loadingListExtraProduct: false,
        errorListExtraProduct: action.payload,
      };
    default:
      return state;
  }
};

export const deleteProductReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_DELETE_REQUEST:
      return { loadingProductDelete: true };
    case PRODUCT_DELETE_SUCCESS:
      toast.success("This Product has been successfully deleted.");
      return {
        loadingProductDelete: false,
        successProductDelete: true,
      };
    case PRODUCT_DELETE_FAIL:
      return {
        loadingProductDelete: false,
        errorProductDelete: action.payload,
        successProductDelete: false,
      };
    default:
      return state;
  }
};

export const updateProductReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_UPDATE_REQUEST:
      return { loadingProductUpdate: true };
    case PRODUCT_UPDATE_SUCCESS:
      toast.success("This Product has been successfully updated");
      return {
        loadingProductUpdate: false,
        successProductUpdate: true,
      };
    case PRODUCT_UPDATE_FAIL:
      return {
        loadingProductUpdate: false,
        errorProductUpdate: action.payload,
        successProductUpdate: false,
      };
    default:
      return state;
  }
};

export const detailProductReducer = (state = { productInfo: {} }, action) => {
  switch (action.type) {
    case PRODUCT_DETAIL_REQUEST:
      return { loadingProductInfo: true };
    case PRODUCT_DETAIL_SUCCESS:
      return {
        loadingProductInfo: false,
        successProductInfo: true,
        productInfo: action.payload.product,
      };
    case PRODUCT_DETAIL_FAIL:
      return {
        loadingProductInfo: false,
        successProductInfo: false,
        errorProductInfo: action.payload,
      };
    default:
      return state;
  }
};

export const createNewProductReducer = (state = {}, action) => {
  switch (action.type) {
    case PRODUCT_ADD_REQUEST:
      return { loadingProductAdd: true };
    case PRODUCT_ADD_SUCCESS:
      toast.success("This Product has been added successfully");
      return {
        loadingProductAdd: false,
        successProductAdd: true,
      };
    case PRODUCT_ADD_FAIL:
      toast.error(action.payload);
      return {
        loadingProductAdd: false,
        successProductAdd: false,
        errorProductAdd: action.payload,
      };
    default:
      return state;
  }
};

export const getListProductReducer = (state = { products: [] }, action) => {
  switch (action.type) {
    case PRODUCT_LIST_REQUEST:
      return { loadingListProduct: true, products: [] };
    case PRODUCT_LIST_SUCCESS:
      return {
        loadingListProduct: false,
        products: action.payload.products,
        pages: action.payload.pages,
        page: action.payload.page,
      };
    case PRODUCT_LIST_FAIL:
      return {
        loadingListProduct: false,
        errorListProduct: action.payload,
      };
    default:
      return state;
  }
};
